import * as firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";
import "firebase/auth";
import "firebase/functions";
import "firebase/analytics";
import "firebase/database";
import * as firebaseui from "firebaseui-ja";

import { firebaseConfig } from "@/config/prd/jinro";
import { firebaseConfigStg } from "@/config/stg/jinro";

if (process.env.NODE_ENV === "production") {
  firebase.initializeApp(firebaseConfig);
} else {
  firebase.initializeApp(firebaseConfigStg);
}
firebase.analytics();

export const db = firebase.firestore();
export const realtimedb = firebase.database();
export const storage = firebase.storage();
export const auth = firebase.auth();
export const functions = firebase.functions();
export const authObject = firebase.auth;
export const firestore = firebase.firestore;
export const realtimedatabase = firebase.database;

export const ui = new firebaseui.auth.AuthUI(firebase.auth());
